@if (form) {
  <div class="astral-sidebar-shell" [formGroup]="form">
    <div class="astral-sidebar-content astral-stack-l">
      <header>
        <h2>{{ 'COMPANY.SYSTEM_SETTINGS_BULK.TITLE' | translate }}</h2>
      </header>
      <app-information-block
        [text]="'COMPANY.SYSTEM_SETTINGS_BULK.SELECTED_COMPANIES' | translate: { count: affectedCompaniesCount }"
      ></app-information-block>
      <section class="astral-section-surface astral-stack-m">
        <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
          <astral-select [control]="form.controls['target']" [itemsSource]="targets"></astral-select>
          <astral-toggle [control]="form.controls['enabled']"></astral-toggle>
        </astral-layout-group>
      </section>
      @if (target === bulkTarget.InvoiceReminder && showDetails) {
        <section class="astral-section-surface astral-stack-m">
          <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
            <astral-input [control]="form.controls['remindAfterDays']" [type]="'number'"></astral-input>
            <astral-select [control]="form.controls['reminderDeliveryMethod']" [itemsSource]="reminderDeliveryMethods"></astral-select>
          </astral-layout-group>
        </section>
      }
      @if (target === bulkTarget.AutomaticAdvicing && showDetails) {
        <section class="astral-section-surface">
          <astral-input [control]="form.controls['automaticAdvicingDayInMonth']" [type]="'number'"></astral-input>
        </section>
      }
      @if (target === bulkTarget.FaultNotification && showDetails) {
        <section class="astral-section-surface astral-stack-m">
          <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
            <astral-toggle [control]="form.controls['sendLandlordNotification']"></astral-toggle>
            @if (showFaultNotificationReceivers) {
              <astral-input
                [control]="form.controls['faultNotificationReceivers']"
              ></astral-input>
            }
          </astral-layout-group>
        </section>
      }
      @if (target === bulkTarget.TenantPages && showDetails) {
        <section class="astral-section-surface astral-stack-m">
          <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
            <astral-select [control]="form.controls['tenantPageSource']" [itemsSource]="tenantPageSources"></astral-select>
            @if (showBuiltInTenantPageSettings) {
              <astral-toggle [control]="form.controls['displayDwellingInspection']"></astral-toggle>
            }
            @if (showExternalTenantPageSettings) {
              <astral-input
                class="astral-grid-full"
                [control]="form.controls['tenantPageExternalUrl']"
              ></astral-input>
            }
          </astral-layout-group>
        </section>
        @if (showBuiltInTenantPageSettings) {
          <section class="astral-section-surface astral-stack-m">
            <h3>{{ 'COMPANY.SYSTEM_SETTINGS_BULK.TARGET.TENANT_PAGES' | translate }}</h3>
            <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
              @for (termination of tenantTerminationFields; track termination) {
                <section
                  class="astral-section-surface astral-section-surface--nested astral-stack-s"
                  >
                  <h4>{{ termination.caption | translate }}</h4>
                  <astral-toggle [control]="form.controls[termination.printControl]"></astral-toggle>
                  <astral-toggle [control]="form.controls[termination.onlineControl]"></astral-toggle>
                </section>
              }
            </astral-layout-group>
            <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
              <astral-select
                [control]="form.controls['allowedOnlineTerminationSignature']"
                [itemsSource]="allowedOnlineTerminationSignatureKinds"
              ></astral-select>
              <astral-input [control]="form.controls['onlineTerminlationCallbackEmailAddresses']"></astral-input>
            </astral-layout-group>
            <astral-input [control]="form.controls['invoiceRegistrationMessage']"></astral-input>
            <astral-input [control]="form.controls['invoiceRegistrationMessageRow2']"></astral-input>
            <astral-input [control]="form.controls['invoiceHasAccountMessage']"></astral-input>
            <astral-input [control]="form.controls['invoiceHasAccountMessageRow2']"></astral-input>
          </section>
        }
      }
    </div>
    <footer class="astral-sidebar-footer astral-sidebar-footer--equal-actions">
      <astral-button variant="primary" type="button" labelKey="SAVE_BTN" [disabled]="working" (click)="save()"></astral-button>
      <astral-button variant="secondary" type="button" labelKey="CANCEL_BTN" (click)="cancel()"></astral-button>
    </footer>
  </div>
}
